var map = {
	"./aboutus.svg": 9990,
	"./btn1.svg": 8493,
	"./btn2.svg": 5117,
	"./contact.svg": 8427,
	"./home.svg": 1263,
	"./logo.svg": 9457,
	"./menu.svg": 98,
	"./news.svg": 4249,
	"./production.svg": 7425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9566;